import { useDispatch } from 'react-redux';

import { AppDispatch } from '../store/main.store.ts';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
